import { render, staticRenderFns } from "./KendoGridComponentV2.vue?vue&type=template&id=b9170cb8&scoped=true"
import script from "./KendoGridComponentV2.vue?vue&type=script&lang=js"
export * from "./KendoGridComponentV2.vue?vue&type=script&lang=js"
import style0 from "./KendoGridComponentV2.vue?vue&type=style&index=0&id=b9170cb8&prod&lang=scss"
import style1 from "./KendoGridComponentV2.vue?vue&type=style&index=1&id=b9170cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9170cb8",
  null
  
)

export default component.exports